import { render, staticRenderFns } from "./MsgBanner.vue?vue&type=template&id=245bb138&scoped=true&"
import script from "./MsgBanner.vue?vue&type=script&lang=js&"
export * from "./MsgBanner.vue?vue&type=script&lang=js&"
import style0 from "./MsgBanner.vue?vue&type=style&index=0&id=245bb138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245bb138",
  null
  
)

component.options.__file = "MsgBanner.vue"
export default component.exports